let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ebMC9")).then(() => parcelRequire('dzoJk'));